import { createFileRoute } from '@tanstack/react-router';
import { PassagesPage } from '@/features/settings/passages/passages-page';

/** `?p=<code>`: the selected passage (S24's detail), so a link opens it. */
export const Route = createFileRoute('/_app/settings/passages')({
  validateSearch: (search: Record<string, unknown>): { p?: string } =>
    typeof search.p === 'string' && /^[a-z_]{2,32}$/.test(search.p) ? { p: search.p } : {},
  component: PassagesPage,
});
